module.exports = __webpack_public_path__ + "static/media/CLASP.89586b26.svg";